import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Same-origin on any served domain (custom domains included) so CORS/third-party cookies never apply.
const ORIGIN = window.location.hostname === "localhost" ? BACKEND_URL : window.location.origin;
export const API = `${ORIGIN}/api`;

export const api = axios.create({ baseURL: API, timeout: 180000, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      } finally {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

const FIELD_MSG = Object.fromEntries([
  ["email", "Inserisci un indirizzo email valido."],
  ["password", "La lunghezza minima è di 8 caratteri."],
  ["name", "Il nome può avere al massimo 80 caratteri."],
]);

export function formatApiError(e) {
  if (!e?.response) return e?.code === "ECONNABORTED" ? "Il server non risponde, riprova tra poco." : "Connessione assente. Controlla internet e riprova.";
  const d = e.response.data?.detail;
  if (d == null) return e.response.status >= 500 ? "Errore del server, riprova tra poco." : "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return [...new Set(d.map((x) => FIELD_MSG[x?.loc?.[x.loc.length - 1]] || (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))))].join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export async function fetchLeagues() {
  const { data } = await api.get("/leagues");
  return data.leagues;
}

export async function fetchMatches({ date, status, league } = {}) {
  const params = {};
  if (date) params.date = date;
  if (status) params.status = status;
  if (league) params.league = league;
  const { data } = await api.get("/matches", { params });
  return data.matches;
}

export async function fetchMatch(id) {
  const { data } = await api.get(`/matches/${encodeURIComponent(id)}`);
  return data;
}

export async function fetchPrediction(id, refresh = false) {
  const { data } = await api.get(`/matches/${encodeURIComponent(id)}/prediction`, {
    params: refresh ? { refresh: true } : {},
  });
  return data;
}

export function romeDate(offsetDays = 0) {
  const d = new Date(Date.now() + offsetDays * 86400000);
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
  return parts.replaceAll("-", "");
}
